import { Col, Row } from "antd";
import React from "react";


const DataCounterCard = ({ count, singular, plural }) => {
    const isSingular = count === 1;
    const description = isSingular ? singular : plural;

    return (
        <Row gutter={24}>
            <Col span={24}>
                <h4 className="m-0 p-0">{`${count} ${description}`}</h4>
            </Col>
        </Row>
    );
};

export default DataCounterCard;